import styled from "styled-components/macro";

export const ContainerMetadata = styled.div``;
